import { defineMessages } from 'react-intl';

type MessageKeys = 'betaTag' | 'inactiveActionTooltip';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		betaTag: {
			id: 'rovo-chat.view-agent.beta-tag',
			defaultMessage: 'Beta',
			description: 'Tag to display for beta actions',
		},
		inactiveActionTooltip: {
			id: 'rovo-chat.view-agent.inactive-action-tooltip',
			defaultMessage: 'Inactive',
			description: 'Tooltip to display for inactive actions',
		},
	});

export default message;
